import * as React from "react";
import type { HTMLAttributes } from "react";
import { clsx } from "clsx";
import { ICONS, type IconType } from "./IconType.gen";
import type { ColorVar } from "@/lib/client/utils/theme/types";

export interface IconProps extends HTMLAttributes<HTMLElement> {
  icon: IconType;
  className?: string;
  /** optionally specify the icon size using Tailwinds size options eg text-2xl */
  size?: string;
  /** optionally specify icon color - default inherits from css color */
  color?: `text-${ColorVar}` | string | undefined;
}

export const Icon = ({ icon, className, size, color, ...rest }: IconProps) => {
  const dpIcon = `dp-${icon}`;
  const textColor = color ?? undefined;
  const textSize = size ?? undefined;
  const twClassNames = `leading-none h-fit select-none`;

  return <i {...rest} className={clsx(dpIcon, textColor, textSize, className, twClassNames)} />;
};

const DpCustomIconIdSet = new Set<string>(Object.keys(ICONS));

export const isIcon = (icon: unknown): icon is IconType => {
  return typeof icon === "string" && DpCustomIconIdSet.has(icon);
};
